import { FeatureFlagKey } from "@redotech/feature-flags-model/keys";

export function isNewShipmentDetailsEnabled({
  featureFlags,
}: {
  featureFlags?: Partial<Record<FeatureFlagKey, boolean>> | null;
}): boolean {
  return featureFlags?.[FeatureFlagKey.NEW_SHIPMENT_DETAILS] === true;
}
